import React from 'react';
import { IResource } from 'utils/types';
import ResourceListSection from 'components/Resources/ResourceListSection';

export interface IResourceListContainer {
  content: {
    slug: string;
    resources: IResource[];
  };
}

export const ResourceListContainer: React.FC<IResourceListContainer> = (
  props,
) => {
  const { content } = props;

  if (!content) return null;

  const { slug, resources } = content;

  return (
    <>
      <ResourceListSection slug={slug} resources={resources} />
    </>
  );
};

export default ResourceListContainer;
